import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { LFDropdownModule } from '../../../../../shared/dropdown/dropdown.module';
import { BillPayAccountsTableComponent } from './bill-pay-accounts-table.component';
import { BillPayService } from '../../../../../../services/members/bill-pay.service';
import { AddBillPayAccountModule } from '../../../../bill-pay/add-bill-pay-account/add-bill-pay-account.module';
import { ConfirmDeleteModalModule } from '../../../../shared/confirm-delete-modal/confirm-delete-modal.module';
import { MicrodepositVerificationModule } from '../../../../shared/bank-account-manager/microdeposit-verification/microdeposit-verification.module';
import { LoadingDialogModule } from '../../../../shared/loading-dialog/loading-dialog.module';
import { LegfiDatePipeModule } from '../../../../../../pipes/format/legfi-date.module';
import { EditBillPayAccountModule } from '../../../../bill-pay/edit-bill-pay-account/edit-bill-pay-account.module';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
        LFDropdownModule,

        // Dialogs
        AddBillPayAccountModule,
        EditBillPayAccountModule,
        ConfirmDeleteModalModule,
        MicrodepositVerificationModule,
        LoadingDialogModule,
        LegfiDatePipeModule,
    ],
    declarations: [BillPayAccountsTableComponent],
    exports: [BillPayAccountsTableComponent],
    providers: [
        BillPayService,
    ],
})
export class BillPayAccountsTableModule
{
}
